// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file sales/create_sale.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { InsuranceInfo, PaymentInfo, SaleItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.CreateSaleRequest
 */
export class CreateSaleRequest extends Message<CreateSaleRequest> {
  /**
   * The ID of the patient for whom the sale is being created
   *
   * @generated from field: string patient_id = 1;
   */
  patientId = "";

  /**
   * List of items being sold in the sale
   *
   * @generated from field: repeated com.neulink.pharmacy.SaleItem items = 2;
   */
  items: SaleItem[] = [];

  /**
   * List of payment information for the sale
   *
   * @generated from field: repeated com.neulink.pharmacy.PaymentInfo payments = 3;
   */
  payments: PaymentInfo[] = [];

  /**
   * Insurance information for the sale, if applicable
   *
   * @generated from field: com.neulink.pharmacy.InsuranceInfo insurance = 4;
   */
  insurance?: InsuranceInfo;

  /**
   * Flag indicating if the insurance is valid
   *
   * @generated from field: bool is_valid_insurance = 5;
   */
  isValidInsurance = false;

  constructor(data?: PartialMessage<CreateSaleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreateSaleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "patient_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "items", kind: "message", T: SaleItem, repeated: true },
    { no: 3, name: "payments", kind: "message", T: PaymentInfo, repeated: true },
    { no: 4, name: "insurance", kind: "message", T: InsuranceInfo },
    { no: 5, name: "is_valid_insurance", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSaleRequest {
    return new CreateSaleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSaleRequest {
    return new CreateSaleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSaleRequest {
    return new CreateSaleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSaleRequest | PlainMessage<CreateSaleRequest> | undefined, b: CreateSaleRequest | PlainMessage<CreateSaleRequest> | undefined): boolean {
    return proto3.util.equals(CreateSaleRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CreateSaleResponse
 */
export class CreateSaleResponse extends Message<CreateSaleResponse> {
  /**
   * The ID of the created sale
   *
   * @generated from field: string sale_id = 1;
   */
  saleId = "";

  /**
   * The receipt number for the sale
   *
   * @generated from field: string receipt_number = 2;
   */
  receiptNumber = "";

  constructor(data?: PartialMessage<CreateSaleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreateSaleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sale_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "receipt_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSaleResponse {
    return new CreateSaleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSaleResponse {
    return new CreateSaleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSaleResponse {
    return new CreateSaleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSaleResponse | PlainMessage<CreateSaleResponse> | undefined, b: CreateSaleResponse | PlainMessage<CreateSaleResponse> | undefined): boolean {
    return proto3.util.equals(CreateSaleResponse, a, b);
  }
}

